<template>
    <div class="head" @click="showMenu = true">
        <div class="title">{{ headerIntegration.title }}</div>
        <div class="secondTitle">{{ headerIntegration.secondTitle }}</div>
        <div class="date">{{ getDateAndTimeStr() }}</div>
        <div class="logo"></div>
        <div class="off"></div>
        <div class="menu" v-show="showMenu">
            <div style="flex-direction: column" class="center">
                <router-link :to="{ path: '/homeAll' }"></router-link>
                <div>首页</div>
            </div>
            <div style="flex-direction: column" class="center">
                <router-link :to="{ path: '/teamMan' }"></router-link>
                <div>劳务管理</div>
            </div>
            <div style="flex-direction: column" class="center">
                <router-link :to="{ name: 'devWarn' }"></router-link>
                <div>安全管理</div>
            </div>
            <div style="flex-direction: column" class="center">
                <router-link :to="{ name: 'dataCount' }"></router-link>
                <div>环境管理</div>
            </div>
        </div>
    </div>
</template>

<script>
import { getDateAndTimeStr } from '../../../../untils/misc.js';

export default {
    name: 'headerIntegration',

    props: {
        headerIntegration: {
            title: String,
            secondTitle: String,
        },
    },

    components: {},

    data() {
        return {
            showMenu: false,
        }
    },

    mounted() {},

    computed: {},

    methods: {
        getDateAndTimeStr() {
            return getDateAndTimeStr(new Date());
        }
    }
}
</script>

<style lang="less" scoped>
.head {
    width: 100vw;
    height: 13.5vh;
    background: url('../../../../assets/image/homeTemp/head.png') no-repeat top/100%;
    display: flex;
    justify-content: center;
}

.title {
    font-size: 24px;
    font-weight: normal;
    letter-spacing: 0.1em;
    color: #C4F9FF;
    cursor: pointer;
}

.secondTitle {
    position: absolute;
    left: 56px;
    top: 20px;
    width: 128px;
    height: 22px;
    font-size: 16px;
    font-weight: normal;
    color: rgba(255, 255, 255, 0.6);
}

.date {
    position: absolute;
    right: 80px;
    top: 12px;
    height: 28px;
    font-family: LCD;
    font-size: 24px;
    font-weight: normal;
    color: #FFFFFF;
}

.logo {
    position: absolute;
    left: 16px;
    top: 16px;
    width: 30px;
    height: 30px;
    background: url('../../../../assets/image/homeTemp/logo.png');
    filter: opacity(0.6000000238418579);
}

.off {
    position: absolute;
    right: 24px;
    top: 12px;
    width: 30px;
    height: 30px;
    background: url('../../../../assets/image/homeTemp/off.png');
}

.menu {
    position: absolute;
    top: 6.02vh;
    width: 49.48vw;
    height: 87.96vh;
    border-radius: 960px;
    background: rgba(17, 17, 17, 0.2);
    backdrop-filter: blur(10px);
    font-size: 18px;
    font-weight: normal;
    color: #FFFFFF;
    > div {
        position: absolute;
        left: 15.57vw;
        top: 5.65vh;
        a {
            width: 4.17vw;
            height: 7.41vh;
            background: url('../../../../assets/image/homeTemp/home.png') no-repeat;
            background-size: contain;
        }
    }
    > div:nth-child(10n+2) {
        left: 22.66vw;
        top: 2.96vh;
        a {
            background: url('../../../../assets/image/homeTemp/labor.png') no-repeat;
            background-size: contain;
        }
    }
    > div:nth-child(10n+3) {
        left: 29.74vw;
        a {
            background: url('../../../../assets/image/homeTemp/safe.png') no-repeat;
            background-size: contain;
        }
    }
    > div:last-child {
        left: 36.82vw;
        top: 12.12vh;
        a {
            background: url('../../../../assets/image/homeTemp/environment.png') no-repeat;
            background-size: contain;
        }
    }
}
</style>
